import { Module, VuexModule, Mutation, Action, MutationAction } from "vuex-module-decorators";
import UserModel from "@/models/User";
import firebase from "firebase";
import _debug from "debug";

const debug = _debug("Mediacao:userModule.ts");

@Module({ name: "UserModule" })
export class UserModule extends VuexModule {
    protected user: UserModel = UserModel.empty();
    protected loadingUser = true;

    public get getUser(): UserModel {
        const theUser = this.user;
        if (typeof theUser.hasRole !== "function") {
            return UserModel.fromJson(theUser);
        }
        if (!theUser.firebase) {
            theUser.setFirebase(firebase.auth().currentUser);
        }
        return theUser;
    }
    public get isLoadingUser(): boolean {
        return this.loadingUser;
    }

    @Mutation
    public setUser(theUser: UserModel) {
        this.user = theUser;
    }

    @Mutation
    public setLoadingUser(loading: boolean) {
        debug("Setting loadingUser = " + loading);
        this.loadingUser = loading;
    }

    @Action
    public async changeUser(user: UserModel) {
        debug("store.userModule.changeUser");
        await this.context.commit("setLoadingUser", false);
        await this.context.commit("setUser", user);
    }
}
